const GalleryData = [
    {
        id: 1,
        cover: require("../../Assets/Walkthrough/gallery1.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 2,
        cover: require("../../Assets/Walkthrough/gallery2.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 3,
        cover: require("../../Assets/Walkthrough/gallery3.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 4,
        cover: require("../../Assets/Walkthrough/gallery4.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 5,
        cover: require("../../Assets/Walkthrough/gallery5.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 6,
        cover: require("../../Assets/Walkthrough/gallery6.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 7,
        cover: require("../../Assets/Walkthrough/gallery7.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 8,
        cover: require("../../Assets/Walkthrough/gallery8.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
      {
        id: 9,
        cover: require("../../Assets/Highlights/highlights.jpg"),
        alttag: "DLF Andheri Mumbai",
      },
]

export default GalleryData;